var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('section',{staticClass:"claim-overview__products"},[_c('BaseHeader',{attrs:{"check-mfa":true}},[_vm._v(" 2.1 "+_vm._s(_vm.$t('claims.new.steps.summary.header'))+" ")]),_c('NewClaimOverviewProducts')],1),_c('NewClaimOverviewDetails')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }